import { Pipe, PipeTransform } from '@angular/core';

import { RestTicketCategoryModel } from '@shared/interfaces/turnover.interface';

@Pipe({
  name: 'ticketCategoryTopicName',
})
export class TicketCategoryTopicNamePipe implements PipeTransform {
  transform(id: number, categories: RestTicketCategoryModel[] = [], isTopic = false): string {
    if (isTopic) {
      const topics = categories.flatMap(el => el.topics);
      const topic = topics.find(el => el.id === id);
      return topic?.name || '';
    }

    const category = categories.find(el => el.id === id);
    return category?.name || '';
  }
}
